import { useCallback } from 'react';
import { useCustomMutation } from './core/useCustomMutation';
import { generateTitleHomeworkHelp } from '../../services/api/wr-tools/generateTitleHomeworkHelp';
import { useAuthContext } from '../auth/useAuthContext';
import { useEditorContext } from '../editor/useEditorContext';
import { Phrases } from '../../utilities/constants/phrases';

export const useGenerateTitleHomeworkHelp = () => {
  const {
    userHomeworkHelpRequest,
    userHomeworkHelpTextFromFiles,
    EditorActionCreator,
    editorDispatch,
  } = useEditorContext();
  const { clientHash } = useAuthContext();

  const { error, isLoading, isSuccess, mutateAsync } = useCustomMutation(
    generateTitleHomeworkHelp,
    {
      onSettled: (response) => {
        editorDispatch(
          EditorActionCreator.setGenerationTitle(
            response?.data?.title || Phrases.PREMIUM_ANSWER_PLACEHOLDER_TITLE
          )
        );
      },
    }
  );

  const generateTitleHomeworkHelpMutation = useCallback(
    () =>
      mutateAsync({
        clientHash,
        instructions: userHomeworkHelpRequest,
        instructionsFromFiles: userHomeworkHelpTextFromFiles,
      }),
    [
      clientHash,
      userHomeworkHelpRequest,
      userHomeworkHelpTextFromFiles,
      mutateAsync,
    ]
  );

  return {
    error,
    isTitleGenerating: isLoading,
    isTitleGenerationSuccess: isSuccess,
    generateTitleHomeworkHelpMutation,
  };
};
